import axios from 'axios';
import { utilityService } from '@/services/utilityService.js';

function __getSection (surveyId, sectionId, fnCallback) {
    return axios.get(utilityService.getApiUrl('admin/survey/' + surveyId + '/section/' + sectionId),
        // Third parameter is the configuration object
        {
            headers: utilityService.getHeaders()
        }
    );
}

function __deleteSection (surveyId, sectionId, fnCallback) {
    return axios.delete(utilityService.getApiUrl('admin/survey/' + surveyId + '/section/' + sectionId),
        // Third parameter is the configuration object
        {
            headers: utilityService.getHeaders()
        }
    );
}

function __updateSection (surveyId, sectionId, json) {
    // /api/survey/section/2
    return axios.put(utilityService.getApiUrl('admin/survey/' + surveyId + '/section/' + sectionId),
        json,
        // Third parameter is the configuration object
        {
            headers: utilityService.getHeaders()
        }
    );
}

function __getReports () {
    // /api/report/
    return axios.get(utilityService.getApiUrl('report'),
        // Third parameter is the configuration object
        {
            headers: utilityService.getHeaders()
        }
    );
}

// function __getReportRecords (reportId) {
//     // /api/report/{reportId}
//     return axios.get(utilityService.getApiUrl('report/' + reportId),
//         // Third parameter is the configuration object
//         {
//             headers: utilityService.getHeaders()
//         }
//     );
// }

// function __getReportRecordDetails (reportId, recordId) {
//     // /api/report/{reportId}/{recordId}
//     return axios.get(utilityService.getApiUrl('report/' + reportId + '/' + recordId),
//         // Third parameter is the configuration object
//         {
//             headers: utilityService.getHeaders()
//         }
//     );
// }

// For 100M Diff Report Only
function __getReportDetails (volumeId) {
    // /api/report/{volumeId}
    return axios.get(utilityService.getApiUrl('report/reportdetails/' + volumeId),
        {
            headers: utilityService.getHeaders()
        }
    );
}

// For 100M Diff Report Only
function __getReportRecords (officeId, recordId) {
    // /api/report/{reportId}/{recordId}
    return axios.get(utilityService.getApiUrl('report/reportrecords/' + officeId + '/' + recordId),
        // Third parameter is the configuration object
        {
            headers: utilityService.getHeaders()
        }
    );
}

export const adminService = {
    getSection: (surveyId, sectionId) => __getSection(surveyId, sectionId),
    deleteSection: (surveyId, sectionId) => __deleteSection(surveyId, sectionId),
    updateSection: (surveyId, sectionId, answer) => __updateSection(surveyId, sectionId, answer),
    getReports: () => __getReports(),
    // getReportRecords: (reportId) => __getReportRecords(reportId),
    // getReportRecordDetails: (reportId, recordId) => __getReportRecordDetails(reportId, recordId),

    getReportDetails: (volumeId) => __getReportDetails(volumeId),
    getReportRecords: (officeId, volumeId) => __getReportRecords(officeId, volumeId)
};
